module.exports = __webpack_public_path__ + "img/39_46.5666afef.png";